import { cn } from '../lib/cn.js';

/**
 * `.entete` du kit (Braise 2) : le moment en sur-titre, le titre, les actions.
 *
 * Sur un téléphone la barre du haut porte déjà les actions (`MobileTopBar`) : l'en-tête n'y
 * garde que le texte, et la barre ne redit pas le titre (`ROUTES_AVEC_ENTETE`).
 */
export function PageHeader({
  title,
  surtitre,
  actions,
  className,
}: {
  title: string;
  surtitre?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return (
    <header className={cn('entete', className)}>
      <div className="entete-texte">
        {surtitre && <p className="entete-surtitre">{surtitre}</p>}
        <h1 className="entete-titre">{title}</h1>
      </div>
      {actions && <div className="entete-actions hidden md:flex">{actions}</div>}
    </header>
  );
}

/** Les vues qui portent leur propre en-tête : la barre du haut mobile n'y écrit pas de titre. */
export const ROUTES_AVEC_ENTETE: readonly string[] = ['/', '/today', '/board', '/courses', '/tracker', '/calories'];
